<template>
  <div class="user-verify">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>审核授权</el-breadcrumb-item>
      <el-breadcrumb-item>用户申请管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form">

        <el-form-item  label="审批状态">
          <el-select  size="mini" v-model="searchParams.apptype" style="width:100px;" filterable placeholder="授权状态">
                  <el-option
                      v-for="item in authstates"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item>
        <el-form-item  label="申请类型">
          <el-select  size="mini" v-model="searchParams.includeproposals" style="width:100px;" filterable placeholder="申请数据类型">
                  <el-option
                      v-for="item in Includedatas"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="`${$t('UserVerify.applicant')}:`">
          <el-autocomplete
            size="mini"
            placeholder=""
            style="width: 200px"
            v-model="searchParams.useremail"
            :fetch-suggestions="emailquerySearch"
            :trigger-on-focus="false"
            clearable>
          </el-autocomplete>
        </el-form-item>  
        <el-form-item :label="$t('proposal.obs_id')">
          <el-autocomplete
            size="mini"
            placeholder=""
            style="width: 220px"
            v-model="searchParams.obs_id"
            :fetch-suggestions="querySearch"
            :trigger-on-focus="false"
            clearable>
          </el-autocomplete>
        </el-form-item> 
        <el-form-item :label="`${$t('proposal.condition.proposal')}:`">
          <el-autocomplete
            size="mini"
            placeholder=""
            style="width: 200px"
            v-model="searchParams.proposal"
            :fetch-suggestions="proquerySearch"
            :trigger-on-focus="false"
            clearable>
          </el-autocomplete>
        </el-form-item>    
        <el-form-item :label="`${$t('proposal.target')}:`">
          <el-input size="mini" style="width: 120px" v-model="searchParams.target"></el-input>
        </el-form-item>    
        <el-form-item :label="`${$t('proposal.obs_mode')}:`">
          <el-input size="mini" style="width: 60px" v-model="searchParams.obs_mode"></el-input>
        </el-form-item>


        <el-form-item>
          <el-button size='mini' type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- <div>
        <el-button
              class="download-all"
              type="text"
              size="small">
              批量下载
        </el-button>
        <el-button
              class="apply-all"
              type="text"
              size="small">
              批量申请
        </el-button>
      </div> -->
      <el-table
        :data="datalist"
        style="width: 100%"
        @sort-change="sortChange">
        <el-table-column
          type="selection"
          width="55"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="idai"
          label="ID"
          v-if="false">
        </el-table-column>
        <el-table-column
          width="80"
          prop="name"
          label="申请人">
        </el-table-column>
        <el-table-column
          prop="useremail"
          label="申请人邮箱">
        </el-table-column>
        <el-table-column
          width="80"
          :label="$t('UserVerify.Applicationtype')">
          <template slot-scope="{row}">
            <span :title="$t(`UserVerify.includeproposal.${row.includeproposal}`)">{{$t(`UserVerify.includeproposal.${row.includeproposal}`)}}</span>
          </template>>
        </el-table-column>
        <el-table-column
          prop="applycop"
          label="申请人机构">
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="apply_date"
          label="申请日期">
        </el-table-column>
        <el-table-column
          prop="data_id"
          label="文件ID"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="appcontent"
          width="320"
          label="申请内容">
        </el-table-column>
        <el-table-column
          prop="obs_id"
          label="观测号"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="target"
          label="观测目标"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="obs_mode"
          label="观测模式"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="proposal"
          label="观测提案"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="数据用途"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="auth_code"
          label="授权码"
          v-if="false">
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="authed_date"
          label="授权日期">
        </el-table-column>
        <el-table-column
          prop="sys_validity"
          label="系统有效期"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="end_date"
          label="失效日期">
        </el-table-column>
        <el-table-column
          prop="state"
          label="申请状态">
        </el-table-column>
        <el-table-column
          prop="auth_states"
          label="授权状态"
          v-if="false">
        </el-table-column>
        <el-table-column
          width="150"
          label="操作">
          <template slot-scope="scope">

            <!-- <el-link type="primary" :href="`/download/${scope.row.idai}`" target="_blank">下载</el-link> -->

            <el-button
              v-show="scope.row.isAuth"
              class="copy-btn"
              :data-clipboard-text="scope.row.idai"
              type="text"
              size="small"
              @click="userverok(scope.row.idai)">
              审核
            </el-button>
            <el-button
              v-show="scope.row.isOk"
              class="copy-btn"
              :data-clipboard-text="scope.row.idai"
              type="text"
              size="small"
              @click="uservercancel(scope.row)">
              {{$t('UserVerify.closever')}}
            </el-button>


          
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>
    </div>  
  </div>
</template>

<script>
import {AuthStates,Includedata} from '../common';
import axios from 'axios';

export default {
  name: 'UserVerify',
  data() {
    return {
      searchParams: {
        proposal:'',
        includeproposals:'all',
        obs_id:'',
        useremail:'',
        target:'',
        obs_mode:'',
        apptype:'all',
      },
      list: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      // checkedisstate:false,
      authstates: AuthStates,
      Includedatas:Includedata,
      applyIsVisible: false,
      currentDataId: '',
      restaurants:[],
      prorestaurants:[],
      emailrestaurants:[],
      orderDirection: null,
      orderProp: '',
    };
  },
  computed: {
    datalist() {
      return this.list.map((item) => {
        let isAuth = false;
        let isOk = false;
        //authcode 是待数据管理员审批流程的状态码
        let authcode = [1002,1012,1023,1033,1044,1047,1053,1063];
        let okcode = [1071,1072,1073,1074,1075,1076,1077,1078,5000];
        isAuth = authcode.indexOf(item.state_code)>-1;
        isOk = okcode.indexOf(item.state_code)>-1;
        return {
          ...item,
          isAuth,
          isOk,
        }
      });
    },
  },
  created() {
    this.getData();
    this.getobslistdata();
    this.getprolistdata();
    this.getemaillistdata();
  },
  methods: {
    getData() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchParams,
      }
      if (this.orderDirection && this.orderProp) {
        params.orderDirection = this.orderDirection;
        params.orderProp = this.orderProp;
      }
      axios.post('/iapi/getDMappData', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          // this.list = res.data.data.list;
          this.list = res.data.data.list.map((item) => {
            let include = item.includeproposal;
            let appcontent = '';
            switch(include){
              case '1':
                appcontent = '观测ID: '+item.obs_id;
                break;
              case '2':
                appcontent = '提案号：'+item.proposal;
                break;
              case '3':
                appcontent = '提案号: '+item.proposal+'  观测模式: '+item.obs_mode+'  观测目标: '+item.target;
                break;
            }
            return {
              ...item,
              appcontent,
            }
            
          })
        }
      });
      // console.log("list",this.list);
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    verok(dataId) {
      const params = {
        data_id: dataId,
      };
      axios.post('/iapi/verok', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('同意申请，请等待邮箱回复');
        }
      });
      this.getData();
    },
    uservercancel(dataitem) {
      // console.log('dataitem',dataitem);
      const params = {
        idai: dataitem.idai,
        states_list: dataitem.states_list,
      };
      axios.post('/iapi/datamanagercancel', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('管理员直接取消授权');
        }
      });
      this.getData();
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    sizeChange() {
      this.getData();
    },
    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },
    proquerySearch(queryString, cb) {
      let prorestaurants = this.prorestaurants;
      let results = queryString ? prorestaurants.filter(this.procreateFilter(queryString)) : prorestaurants;
      cb(results);
    },
    procreateFilter(queryString) {
      return (prorestaurants) => {
        return (prorestaurants.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },
    
    emailquerySearch(queryString, cb) {
      let emailrestaurants = this.emailrestaurants;
      let results = queryString ? emailrestaurants.filter(this.emailcreateFilter(queryString)) : emailrestaurants;
      cb(results);
    },
    emailcreateFilter(queryString) {
      return (emailrestaurants) => {
        return (emailrestaurants.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },
    getobslistdata(){
      axios.post('/iapi/getobslist').then((res) => {
        if (res.data.errcode === 0) {
          this.restaurants = res.data.data;
        }
      });
    },
    getprolistdata(){
      axios.post('/iapi/proposallist').then((res) => {
        if (res.data.errcode === 0) {
          this.prorestaurants = res.data.data;
        }
      });
    },
    getemaillistdata(){
      axios.post('/iapi/emaillist').then((res) => {
        if (res.data.errcode === 0) {
          this.emailrestaurants = res.data.data;
        }
      });
    },
    sortChange(param) {
      this.orderDirection = param.order;
      this.orderProp = param.prop;
      this.currentPage = 1;
      this.getData();
    },
  },
};
</script>

<style scoped>
.user-verify {
    padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 0px;
    margin-bottom: 0px;
}
.admin-path {
  margin-bottom: 16px;
}
</style>